import { z } from "zod";

export const apiKeySchema = z.object({
  name: z
    .string()
    .min(1, "Name is required")
    .max(255, "Name must be 255 characters or less"),
  service_id: z.string().nullable(),
});

export type ApiKeyFormData = z.infer<typeof apiKeySchema>;
